import { render, staticRenderFns } from "./bidding02.vue?vue&type=template&id=d06696b6&scoped=true&"
import script from "./bidding02.vue?vue&type=script&lang=js&"
export * from "./bidding02.vue?vue&type=script&lang=js&"
import style0 from "./bidding02.vue?vue&type=style&index=0&id=d06696b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06696b6",
  null
  
)

export default component.exports